module.exports = __webpack_public_path__ + "img/Huygenstijdmachine_Stichting-Thurkow-fonds.aee0125b.svg";